import AccomodationServiceFamily, {IAccomodationServiceFamily} from "@/model/ServiceFamily/AccomodationServiceFamily"

export interface IParkingServiceFamily extends IAccomodationServiceFamily {

}

class ParkingServiceFamily extends AccomodationServiceFamily implements IParkingServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}

export default ParkingServiceFamily